import { CircularProgress } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors, fonts } from '~/layout';

export const BtnSubmit = lib.styled.button`
  display: flex;
  width: 255px;
  height: 45px;
  background: linear-gradient(50.28deg, #67C2E4 2.79%, #0C4BBC 73.37%);
  border-radius: 25px;
  outline: none;
  border: 0!important;
  text-transform: uppercase;
  font-weight: bold;
  font-size: ${fonts.btnSubmitLoginSize}px;
  text-align: center;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  span {
    margin-top: 2px;
    opacity: ${props => (props.disabled ? 0.7 : 1)}
    color: ${colors.white};
    text-align: center;
    align-items: center;
    justify-content: center;
    font-size: ${fonts.btnSubmitLoginSize}px;
  }
`;

export const CircularProgressStyled = lib.styled(CircularProgress)`
  color: ${colors.white}!important;
  width: 20px!important;
  height: 20px!important;
`;
